<template>
	<ActivityLayout class="goal-kr-name-activity">
		<template #badge>
			<NameChangeActivityBadge />
		</template>
		<template #text>
			<p v-html="translate( `text`, {
				changedBy: activity.changedBy,
				from: activity.from,
				to: activity.to
			} )"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import NameChangeActivityBadge from "../Activity/NameChangeActivityBadge.vue";

export default {
	name: "GoalKRNameActivity",
	components: {
		ActivityLayout,
		NameChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, to:String, from:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalKRNameActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
